import React from 'react';
import PropTypes from 'prop-types';

import {MapContainer, TileLayer, Marker, Circle, useMapEvent} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix for default marker icon issue in Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

const MapComponent = (props) => {
  const {height, width, coordinates, radius, onLocationClick, zoomLevel=15, showMarker=true} = props;

  const MapHandler = (props) => {
    const {onLocationClick} = props;
    useMapEvent('click', (e) => {
      if (onLocationClick) {
        onLocationClick(e.latlng);
      }
    });
    return null;
  };
  MapHandler.propTypes = {
    onLocationClick: PropTypes.func,
  };

  return (
    <MapContainer
      center={coordinates}
      zoom={zoomLevel}
      style={{
        height: height,
        width: width,
      }}
    >
      <MapHandler onLocationClick={onLocationClick} />
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      {showMarker && <Marker position={coordinates} />}
      {
        radius && (
          <Circle center={coordinates} radius={radius} />
        )
      }
    </MapContainer>
  );
};

MapComponent.propTypes = {
  height: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
  coordinates: PropTypes.array.isRequired,
  showMarker: PropTypes.bool,
  zoomLevel: PropTypes.number,
  radius: PropTypes.number,
  onLocationClick: PropTypes.func,
};

export default MapComponent;
